<template>
	<div class="pr-5 pl-5 pt-3 page-fill">
		<div class="row w-full mb-3 justify-between flex" style="align-items: center">
			<h1>Activities</h1>
			<div class="cardbody">
				<div class="flex flex-row-reverse items-center">
					<div class="flex flex-row-reverse items-center gap-3">
						<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton'">
							<img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
							<img v-else src="@/assets/filter.svg" class="filterIcon" />
							Filters
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<p class="headerText">
				Define, organize, and manage security controls for your organization's processes/activities, ensuring consistent implementation, ongoing monitoring, and alignment with internal policies and external compliance frameworks. 
			</p>
		</div>
		<div class="mt-5 table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headers" :tableRouteArr="optionsValue" :loadData="dataLoading"></tableData>
			<div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>
		<popup v-if="showActivityPopup" :popUp="showActivityPopup">
				<template v-slot:header>
					<div class="flex items-center justify-between py-4 px-2 rounded">
						<h1 class="pl-2">Activity</h1>
						<button class="float-right text-3xl" @click="onCancelbtn()">
							<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
						</button>
					</div>
				</template>
				<fieldset>
					<div>
						<div>
							<div class="statuscontainer popupbodycontainer">
								<div class="formcontainer flex flex-col">
									<div class="row flex flex-row w-full">
										<div class="row flex flex-row w-full">
											<div class="w-6/12">
												<label class="text-xs font-extrabold">Activity</label>
												<div class="mb-3 mt-2 text-sm">{{ activityObj?.businessProcessName || 'N/A'}}</div>
											</div>
											<div class="w-3/6 leftspacing">
												<label class="text-xs font-extrabold">Team</label>
												<div class="mb-3 mt-2 text-sm">{{ activityObj?.teamName || 'N/A'}}</div>
											</div>
										</div>
									</div>
									<div class="row flex flex-row w-full">
										<div class="">
											<label class="text-xs font-extrabold">Description</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.description || 'N/A' }}</div>		
										</div>
									</div>
									<!-- criticality -->
									<div class="row flex flex-row w-full">
										<div class="w-6/12">
											<label class="text-xs font-extrabold">Activity Owner</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.name || 'N/A'}}</div>
										</div>
										<div class="w-3/6 leftspacing">
											<label class="text-xs font-extrabold">Location</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.displayName || 'N/A' }}</div>
										</div>
									</div>
									<div class="row flex flex-row w-full">
										<div class="w-3/6">
											<label class="text-xs font-extrabold">Criticality</label>
											<!-- <div class="mb-3 mt-2 text-sm">{{ activityObj?.criticality || 'N/A' }}</div> -->
											 <div v-if="activityObj?.criticality"	class="rounded h-5 w-28 mt-2 flex items-center justify-center" :class="colorLabelBg(activityObj.criticality)">
												<div class="text-xs" :class="colorLabelText(activityObj.criticality)">
													{{ getProirityLabel(activityObj.criticality) }}
												</div>
											</div>
										</div>
										<div class="w-3/6 leftspacing">
											<label class="text-xs font-extrabold">Job Title</label>
											<div class="mb-3 mt-2 text-sm">{{ activityObj?.role || 'N/A' }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</popup>
		<!-- <loader v-if="showLoader" /> -->
	</div>
</template>
<style scoped>
</style>
<script lang="ts">
import { emitter, toast } from '@/main';
import { defineComponent } from 'vue';
import useVuelidate from '@vuelidate/core';
import tableData from '@/components/tableData.vue';
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
import { mapGetters } from 'vuex';
// import loader from '@/components/loader.vue';
export default defineComponent({
	data(): any {
		return {
			headers:['_id','Activities','activityTeam', 'EntityofActivity', 'Activity Owner', 'criticality', 'No. of Controls'],

			v$: useVuelidate(),
			departmentsList: [],
			tableRow: [],
			activityObj: {},
			orgUsersList: [],
			optionsUserArray: [],
			controlsCountList: [],
			columnObject: false,
			showActivityPopup: false,
			showLoader: false,
			showFilters: false,
			criticalityArray: [
				{ label: 'Very Low', id: 1 },
				{ label: 'Low', id: 2 },
				{ label: 'Moderate', id: 3 },
				{ label: 'High', id: 4 },
				{ label: 'Critical', id: 5 }
			],
			toolTipActive : false,
			toolTipText : '',
			optionsValue: [
				{
					id: 1,
					value: 'Select',
					route: '/departmentControls',
					presentRoute: '/org/controls/controlMapping'
				}
			],  
			dataLoading:true,
			Entities:[]
		};
	},
	components: {
		tableData,
		// loader,
		popup,
		toolTip
	},
	computed:{
		...mapGetters({dbProcessCriticality:'dbProcessCriticality'}),
	},
	mounted() {
		for (const row of this.tableRow) {
			for (const value of Object.values(row)) {
				if (value == '') {
					this.columnObject = true;
				} else {
					this.columnObject = false;
				}
			}
		}
        emitter.off('ActivityData')
		this.bindRowClickListeners();
		emitter.off('controlMappingData')
        emitter.on("controlMappingData", (isData: any) => {
			let comingId = isData.entityData._id;
			let showObj = this.departmentsList.find((obj: any) => obj._id === comingId);
			this.showEditPopUp(showObj);
        });
		emitter.off('activiteToolTip');
		emitter.on('activiteToolTip', (data: any) => {
			this.toolTipActive = true;
			this.toolTipText = data.tipText
		});
		emitter.off('deActiviteToolTip');
		emitter.on('deActiviteToolTip', (data: any) => {
			this.toolTipActive = false;
			this.toolTipText = ''
		});
		emitter.off('detailsModalClosed');
		emitter.on('detailsModalClosed', this.refreshAfterDetailsModal);
	},
	beforeUnmount() {
		emitter.off('detailsModalClosed', this.refreshAfterDetailsModal);
		if (this.onActivityData) {
			emitter.off('ActivityData', this.onActivityData);
		}
	},
	methods: {
        showActivityDetails(obj:any){
            const row = obj.activeData || obj;
            emitter.emit('openDetailsModal', {
                view: 'departmentControls',
                title: row.Activities || row.businessProcessName || row.displayName || 'Activity',
                params: { id: row._id },
            });
        },
		async refreshAfterDetailsModal() {
			await this.fetchActivitiesList();
			this.bindRowClickListeners();
		},
		bindRowClickListeners() {
			if (this.onActivityData) {
				emitter.off('ActivityData', this.onActivityData);
			}
			this.onActivityData = (isData: any) => {
				this.showActivityDetails(isData);
			};
			emitter.on('ActivityData', this.onActivityData);
		},
		showEditPopUp(obj: any) {
			this.showActivityPopup = true;
			let a = this.dbProcessCriticality.find((value: any)=>{return obj.criticality== value.value}).value;

			let owner = this.optionsUserArray.find((user: any) => user.value === obj.name)?.label || 'N/A';

			let findOwner = this.orgUsersList.find((obj:any)=>{return obj._id === obj.name});
			
			let jobTitle = findOwner!= undefined && findOwner.jobTitle != undefined ? findOwner.jobTitle :'N/A';
			
			if(obj.displayName == "" || obj.entityType == 20301){
				obj.displayName = 'Global'
			}
			if(obj.role == '' || obj.role == undefined || obj != undefined){
                this.orgUsersList.forEach((data: any) => {
                    if(data._id == obj.name){
                        obj.role = data.jobTitle
                    }
                });
             }

			this.activityObj = {...obj}
			this.activityObj.name = owner
			// this.activityObj.role = jobTitle
			this.activityObj.criticality = a
		},
		filterOpen() {
			if(this.columnObject == false){
				this.showFilters = !this.showFilters;
				emitter.emit('visible', this.showFilters);
			}
		},
		onCancelbtn() {
			this.v$.$reset();
			this.showActivityPopup = false;
			this.activityObj = {}
		},
		async getAllUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
				this.orgUsersList = res.data;
			});
			for (var i = 0; i < this.orgUsersList.length; i++) {
				this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
			}
		},
		colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
		colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        getProirityLabel(val:any){			
            if (val === 'N/A') { 
                return 'N/A'; 
            } else {
                let a = this.dbProcessCriticality.find((obj: any) => obj.value == val);
                return (val && typeof val === 'number') ? a.key : 'N/A';
            }
        },
		async fetchControlsCountInfo() {
			this.controlsCountList = [];
			try {
				this.showLoader = true;
				await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/departments/mappedcontrols/count`).then((result: { data: any }) => {
					this.controlsCountList = result.data;
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.showLoader = false;
		},
		async getSingleEntity(){
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
				this.organizationList = res.data;
			});
			for(let i=0;i<this.organizationList.length;i++) {
				this.Entities.push({label:this.organizationList[i].entityDisplayName,value:this.organizationList[i]._id,entityType:this.organizationList[i].entityType})
			}
			// this.$store.dispatch('updateDotsLoading', false);
		},
		async fetchDepartmentsList() {
			try {
				this.showLoader = true;
				this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: { data: any }) => {
					// this.departmentsList = res.data;
					// console.log("departmentsList", this.departmentsList)
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.showLoader = false;
		},
		async fetchActivitiesList() {
			try {
				this.showLoader = true;
				this.tableRow = [];
				this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/processes/mappedcontrols/count`).then((res: { data: any }) => {
					this.departmentsList = res.data;
					if (this.departmentsList.length > 0) {
						this.departmentsList.forEach((department: any) => {
                            let finalObj = {
                                _id: department._id,
								'Activities': department.businessProcessName ? department.businessProcessName: 'N/A',
                                'activityTeam': department.teamName ? department.teamName : 'N/A',
                                'EntityofActivity': department.entityType == 20303 ? department.displayName :this.Entities.find((e:any)=>e.entityType==1)?.label||'N/A' ,
                                'Activity Owner': this.optionsUserArray.find((user: any) => user.value === department.name)?.label || 'N/A',
                                'No. of Controls': department.controlCount && department.controlCount ? department.controlCount : '0',
								'criticality': department.criticality ? department.criticality: 'N/A',
                                'entityId': department.entityDisplayName,
                                'type': department.entityType,
                                'job Title': department.role,
                            };
                            this.tableRow.push(finalObj);
							this.dataLoading = false;
                        });
					}
					else{
						this.dataLoading = false;
					}
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.showLoader = false;
		}
	},
	async created() {
		this.dataLoading = true;
		// await this.fetchControlsCountInfo();
		await this.getAllUsers();
		await this.getSingleEntity();
		await this.fetchActivitiesList();
		// await this.fetchDepartmentsList();
	}
});
</script>